import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CapitalizeCityNamesPipe} from "./pipes/capitalizecitynames";
import {ChunksPipe} from "./pipes/chunks-pipe";
import {CryptoSymbol2NamePipe} from "./pipes/cryptosymbol2name.pipe";
import {Currency2StableCointPipe} from "./pipes/currency2stablecoin.pipe";
import {FeeContentPipe} from "./pipes/feeconcept.pipe";
import {FormatMoneyPipe} from "./pipes/formatmoney";
import {FormatNumberPipe} from "./pipes/formatnumber";
import {KeysPipe} from "./pipes/keys";
import {LCFirstPipe} from "./pipes/lcfirst.pipe";
import {SafePipe} from "./pipes/safe-pipe";
import {SortPipe} from "./pipes/sort";
import {SubStrPipe} from "./pipes/substr";
import {UnescapeCachePipe} from "./pipes/unescape-cache-pipe";
import {FormatCryptoPipe} from "./pipes/formatcrypto";
import {AbbreviateCodePipe} from "./pipes/abbreviatecode.pipe";
import { StripeCardPopupComponent } from "./payment/gateways/stripecardpopup/stripecardpopup.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CapitalizeCityNamesPipe,
    ChunksPipe,
    CryptoSymbol2NamePipe,
    Currency2StableCointPipe,
    FeeContentPipe,
    FormatMoneyPipe,
    FormatNumberPipe,
    FormatCryptoPipe,
    AbbreviateCodePipe,
    StripeCardPopupComponent,
    KeysPipe,
    LCFirstPipe,
    SafePipe,
    SortPipe,
    SubStrPipe,
    UnescapeCachePipe
  ],
  providers: [
    {
      provide: 'isBrowser',
      useValue: typeof window !== 'undefined'
    }
  ],
  exports: [
    CapitalizeCityNamesPipe,
    ChunksPipe,
    CryptoSymbol2NamePipe,
    Currency2StableCointPipe,
    FeeContentPipe,
    FormatMoneyPipe,
    StripeCardPopupComponent,
    FormatNumberPipe,
    FormatCryptoPipe,
    AbbreviateCodePipe,
    KeysPipe,
    LCFirstPipe,
    SafePipe,
    SortPipe,
    SubStrPipe,
    UnescapeCachePipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AhoraCryptoCommonModule {}

